import {Inject, Injectable} from "@angular/core";
import {HttpClient, HttpResponse} from "@angular/common/http";
import * as MsgPack from "../../../node_modules/msgpack-lite";
import {Receipt} from "../types/receipt";
import {BestoranteService} from "./bestorante";
import {TranslateService} from "@ngx-translate/core";
import {PaymentRow} from "../types/paymentrow";
import * as moment from "moment";
import {SaleArticleDto} from "../types/resto";
import {ReceiptRow} from "../types/receiptrow";
import {BestoGoConfigurationDto} from "../types/ca";
import { StorageService } from "./storage.service";
import { Logger, LoggingService } from "ionic-logging-service";
import { RestolutionService } from "./restolution";

@Injectable()
export class UtilsService {

  private logger: Logger;

  constructor(private translate: TranslateService, private storage: StorageService,
    private loggingService: LoggingService ) {
    this.logger = loggingService.getLogger("BestoGo.UtilsService");

  }

  readResponseBlob(resp: HttpResponse<Blob>, process: (e) => any) {
    let arrayBufferNew = null;
    const fileReader = new FileReader();
    fileReader.onload = ((event: any) => {
      arrayBufferNew = event.target.result;
      if (arrayBufferNew.byteLength > 0) {
        process(MsgPack.decode(new Uint8Array(arrayBufferNew)));
      } else {
        process(null);
      }

    }).bind(this);

    fileReader.readAsArrayBuffer(resp.body);
  }

  readBlob(b: Blob, process: (e) => any) {
    let arrayBufferNew = null;
    const fileReader = new FileReader();
    fileReader.onload = ((event: any) => {
      arrayBufferNew = event.target.result;
      if (arrayBufferNew.byteLength > 0) {
        process(MsgPack.decode(new Uint8Array(arrayBufferNew)));
      } else {
        process(null);
      }
    }).bind(this);
    fileReader.readAsArrayBuffer(b);
  }

  getArrayInRows(rows, cols, srcArray: any) {
    const arr = [];
    let indx = 0;
    for (let i = 0; i < rows; i++) {
      const arrA = [];
      for (let j = 0; j < cols; j++) {
        if (srcArray.length < indx + 1) {
          arrA.push(null);
        } else {
          arrA.push(srcArray[indx]);
        }
        indx++;
      }
      if (arr.length < rows) {
        arr.push(arrA);
      }
    }
    return arr;
  }

  clone(source): any {
    return JSON.parse(JSON.stringify(source));
  }

  public convertCondimentsToRows(receipt: Receipt): Receipt {
    const clonedReceipt = this.clone(receipt);
    for (const row of clonedReceipt.rows) {
      if (row.condiments && row.condiments.length > 0) {
        row.condiments = row.condiments.map((c: ReceiptRow) => {
          if (!c.parentRowUuid) {
            c.parentRowUuid = row.uuid;
          }
          if (!c.rowPosition) {
            c.rowPosition = row.rowPosition;
          }
          return c;
        });
        clonedReceipt.rows = clonedReceipt.rows.concat(row.condiments);
        delete row.condiments;
        clonedReceipt.rows = clonedReceipt.rows.map((subRow: ReceiptRow) => {
          if (row.uuid === subRow.uuid && row.rowPosition === subRow.rowPosition) {
            delete subRow.condiments;
          }
          return subRow;
        });
      }
    }
    return clonedReceipt;
  }

  public convertRowsToCondiments(receipt: Receipt): Receipt {
    const clonedReceipt = this.clone(receipt);
    for (const row of clonedReceipt.rows) {
      if (row.parentRowUuid) {
        clonedReceipt.rows.map((parentRow: ReceiptRow) => {
          if (parentRow.uuid === row.parentRowUuid && parentRow.rowPosition === row.rowPosition) {
            if (!parentRow.condiments) {
              parentRow.condiments = [];
            }
            parentRow.condiments.push(row);
            clonedReceipt.rows = clonedReceipt.rows.filter((filteredRow: ReceiptRow) =>
              filteredRow.uuid !== row.uuid);
          }
        });
      }
    }
    return clonedReceipt;
  }

  public cardRawDataToSlip(paymentRow: PaymentRow, rawData, lineWidth) {
    let outputs = [];
    if (rawData && rawData.merchant_receipt && rawData.merchant_receipt.text) {
      outputs = rawData.merchant_receipt.text.split("\n").map((t) =>  this.rightPad(t, " ", lineWidth));
      this.logger.debug("cardRawDataToSlip", "Outputs", outputs);
    }
    this.logger.debug("cardRawDataToSlip", "rawData", rawData);
    return outputs;
  }

  public rowsToReceipt(r, rows, lineWidth, date, receiptNumber, conf: BestoGoConfigurationDto, extraText?, restaurant?, clerkID?) {
    const outputs = [];
    let orgHeader1 = "";
    if (window.localStorage.getItem("placeName")) {
      orgHeader1 = window.localStorage.getItem("placeName");
    }
    let orgHeader2 =  this.translate.instant("Payment receipt");
    let footer1 = this.translate.instant("Thank you for your visit!");
    let priceCoef = 1;
    if (r.cancelReceipt) {
      orgHeader2 = this.translate.instant("CANCELLATION");
      footer1 = this.translate.instant("CANCELLATION");
      priceCoef = -1;
    }
    let totalSum = 0;
    const vats = {};
    if (extraText) {
      outputs.push(this.middlePad(extraText, " ", lineWidth));
      orgHeader2 = "";
    }
    if (restaurant?.n) {
      outputs.push(this.middlePad(restaurant?.n, " ", lineWidth));
    }
    if (restaurant?.addr) {
      outputs.push(this.middlePad(restaurant?.addr + ", " + restaurant?.pi + " " + restaurant?.city, " ", lineWidth));
    }
    if (restaurant?.tel) {
      outputs.push(this.middlePad(restaurant?.tel, " ", lineWidth));
    }
    if (restaurant?.www) {
      outputs.push(this.middlePad(restaurant?.www, " ", lineWidth));
    }
    outputs.push(this.middlePad(orgHeader1, " ", lineWidth));
    outputs.push(this.middlePad(orgHeader2, " ", lineWidth));
    outputs.push(this.middlePad(" ", " ", lineWidth));
    outputs.push(this.rightPad(this.translate.instant("Receipt") + " " + receiptNumber, " ", lineWidth));
    outputs.push(this.leftPad(this.formatDateTime(date), " ", lineWidth));
    if (clerkID) {
      outputs.push(this.leftPad(this.translate.instant("Clerk ID") + " " + clerkID, " ", lineWidth));
    }
    if (conf && conf.crMachineNumber) {
      this.logger.debug("rowsToReceipt", "Conf: ", conf);
      outputs.push(this.leftPad(conf.crMachineNumber + " " + conf.appVersion,
        " ", lineWidth));
    }
    outputs.push(this.rightPad("", " ", lineWidth));
    for (const o of rows) {
      let rowSum = parseFloat(o.price) * parseFloat(o.amount);
      if (o.discount) {
        if (o.discount.type === "%") {
          rowSum -= rowSum * o.discount.value / 100;
        } else {
          rowSum -= o.discount.value;
        }
      }
      totalSum += priceCoef * rowSum;
      const rowName = o.parentRowUuid ? "  " + o.name : o.name;
      outputs.push(this.rightPad(rowName, " ", lineWidth - 8) +
        this.leftPad(((priceCoef * parseFloat(o.price)) * parseFloat(o.amount)).toFixed(2), " ", 8));
      if (o.amount > 1) {
        outputs.push(this.rightPad(" ", " ", lineWidth - 8) +
          this.leftPad("" + parseFloat(o.amount) + "x" + (priceCoef * parseFloat(o.price)).toFixed(2), " ", 8));
      }
      if (o.discount) {
        if (o.discount.type === "%") {
          outputs.push(this.rightPad("   " + o.discount.name, " ", lineWidth - 8) +
            this.leftPad("-" + o.discount.type + o.discount.value, " ", 8));
        } else {
          outputs.push(this.rightPad("   " + o.discount.name, " ", lineWidth - 9) +
            this.leftPad("-" + parseFloat(o.discount.value).toFixed(2), " ", 9));
        }
      }
      for (const d of r.discounts) {
        if (d.type === "%") {
          rowSum -= rowSum * (d.value / 100);
        } else {
          rowSum -= d.value;
        }
      }
      if (!vats[o.vat]) {
        vats[o.vat] = {vatPercentage: o.vat, totalWithoutVat: 0, totalVat: 0, totalSum: 0};
      }
      vats[o.vat].totalSum += rowSum;
      const vatLessSum = rowSum / (1 + o.vat / 100);
      vats[o.vat].totalWithoutVat += vatLessSum;
      vats[o.vat].totalVat += (rowSum - vatLessSum);
    }
    if (r.discounts && r.discounts.length > 0) {
      outputs.push(this.rightPad(this.translate.instant("Total"), " ", lineWidth - 8) +
        this.leftPad(totalSum.toFixed(2), " ", 8));
      outputs.push(this.middlePad(" ", " ", lineWidth));
       outputs.push(this.rightPad(this.translate.instant("Discounts"), " ", lineWidth));

      for (const d of r.discounts) {
        if (d.type === "%") {
          totalSum -= totalSum * (d.value / 100);
          outputs.push(this.rightPad("  " + d.name, " ", lineWidth - 8) +
            this.leftPad("-" + parseFloat(d.value) + "%", " ", 8));
        } else {
          outputs.push(this.rightPad("  " + d.name, " ", lineWidth - 8) +
            this.leftPad("-" + parseFloat(d.value).toFixed(2), " ", 8));
          totalSum -= d.value;
        }
      }
    }
    outputs.push(this.middlePad(" ", " ", lineWidth));
    outputs.push(this.rightPad(this.translate.instant("Total"), " ", lineWidth - 8) +
      this.leftPad(totalSum.toFixed(2), " ", 8));
    outputs.push(this.middlePad(" ", " ", lineWidth));
    if (r.payments) {
      this.logger.debug("rowsToReceipt", "Payments: ", r.payments);
      for (const p of r.payments) {
        if ((p.payment === "CASH") && p.realSum < p.sum && p.realSum > 0) {
          outputs.push(this.rightPad(this.translate.instant("Cash"), " ", lineWidth - 8) +
            this.leftPad(parseFloat(p.sum).toFixed(2), " ", 8));
          outputs.push(this.rightPad(this.translate.instant("Change"), " ", lineWidth - 8) +
            this.leftPad((parseFloat(p.sum) - parseFloat(p.realSum)).toFixed(2), " ", 8));
        } else {
          let method = p.payment;
          if (method === "CARD") {
            method = this.translate.instant("Card");
          } else if (method === "CASH") {
            method = this.translate.instant("Cash");
          }
          outputs.push(this.rightPad(method, " ", lineWidth - 8) +
            this.leftPad((parseFloat(p.sum)).toFixed(2), " ", 8));

        }
      }
    }
    outputs.push(this.middlePad(" ", " ", lineWidth));
    if (lineWidth > 30) {
      outputs.push(this.rightPad(this.translate.instant("Tax%"), " ", lineWidth - 26) +
        this.leftPad(this.translate.instant("Taxless"), " ", 9) +
        this.leftPad(this.translate.instant("Tax"), " ", 7) +
        this.leftPad(this.translate.instant("With tax"), " ", 10));
      for (const vat of Object.keys(vats)) {
        const v = vats[vat];
        outputs.push(this.rightPad(v.vatPercentage + "%", " ", lineWidth - 26) +
          this.leftPad((priceCoef * parseFloat(v.totalWithoutVat)).toFixed(2), " ", 9) +
          this.leftPad((priceCoef * parseFloat(v.totalVat)).toFixed(2), " ", 7) +
          this.leftPad((priceCoef * parseFloat(v.totalSum)).toFixed(2), " ", 10));
      }
    } else {
      outputs.push(this.rightPad(" %", " ", lineWidth - 24) +
        this.leftPad(this.translate.instant("Taxless"), " ", 9) +
        this.leftPad(this.translate.instant("Tax"), " ", 6) +
        this.leftPad(this.translate.instant("With tax"), " ", 9));
      for (const vat of Object.keys(vats)) {
        const v = vats[vat];
        outputs.push(this.rightPad(v.vatPercentage + "%", " ", lineWidth - 23) +
          this.leftPad((priceCoef * parseFloat(v.totalWithoutVat)).toFixed(2), " ", 8) +
          this.leftPad((priceCoef * parseFloat(v.totalVat)).toFixed(2), " ", 6) +
          this.leftPad((priceCoef * parseFloat(v.totalSum)).toFixed(2), " ", 9));
      }
      if (extraText) {
        outputs.push(this.middlePad(extraText, " ", lineWidth));
      }

    }

    if (r.cancelReceipt) {
      outputs.push(this.rightPad(this.translate.instant("Cancellation"), " ", lineWidth));
      outputs.push(this.rightPad(this.translate.instant("Reason"), ".", lineWidth));
      outputs.push(this.rightPad("", " ", lineWidth));
      outputs.push(this.rightPad("", " ", lineWidth));
      outputs.push(this.rightPad(this.translate.instant("Signed by"), ".", lineWidth));
      outputs.push(this.rightPad("", " ", lineWidth));
      outputs.push(this.middlePad(footer1, " ", lineWidth));
    }
    return outputs;
  }

  public middlePad(str, padString, fullLength) {
    if (!str) {
      str = "";
    }
    const length = str.length;
    const leftPadSize = Math.floor(fullLength / 2 + length / 2);
    str = this.leftPad(str, padString, leftPadSize);
    str = this.rightPad(str, padString, fullLength);
    return str;
  }

  public leftPad(str, padString, length) {
    if (!str) {
      str = "";
    }
    if (str.length > length) {
      return str.substring(0, length);
    }
    while (str.length < length) {
      str = padString + str;
    }
    return str;
  }

  public rightPad(str, padString, length) {
    if (!str) {
      str = "";
    }
    if (str.length > length) {
      return str.substring(0, length);
    }
    while (str.length < length) {
      str = str + padString;
    }
    return str;

  }

  public formatDateTime(date) {
    let str = this.formatDate(date);
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    str = str + " ";
    const hour = date.getHours();
    let hourS = "" + hour;
    if (hour < 10) {
      hourS = "0" + hour;
    }
    const min = date.getMinutes();
    let minS = "" + min;
    if (min < 10) {
      minS = "0" + min;
    }
    const sec = date.getSeconds();
    let secS = "" + sec;
    if (sec < 10) {
      secS = "0" + sec;
    }
    return str + hourS + ":" + minS + ":" + secS;
  }

  public formatPrice(price) {
    if (!price) {
      return "0.00";
    }
    return Number(price).toFixed(2);
  }

  public formatDate(date) {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    let dd = date.getDate();
    let mm = date.getMonth() + 1; //January is 0!
    const yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return dd + "." + mm + "." + yyyy;
  }

  //returns dynamic sort function to be used with .sort
  public dynamicSortFn(property) {
    let sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return (a, b) => {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    };
  }

  //for filtering current day receipts (5AM to 5AM)
  public receiptsFilterFunc(receipt: Receipt, selectedDate: moment.Moment): boolean {
    const maxDate = moment(selectedDate).add(24, "hours");
    return moment(receipt.date).isBetween(selectedDate, maxDate);
  }

  //check if today
  public checkIfToday(someDate: Date) {
    if (!someDate) {
      return false;
    }
    const today = new Date();
    return someDate.getDate() === today.getDate() &&
          someDate.getMonth() === today.getMonth() &&
       someDate.getFullYear() === today.getFullYear();
  }

  //generate UID
  public generateGUIDString() {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now(); //use high-precision timer if available
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      // eslint-disable-next-line no-bitwise
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      // eslint-disable-next-line no-bitwise
      return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  public calculateReceiptVatsReturnVatlessSum(receipt: Receipt) {
    const vats = {};
    let totalVatlessSum = 0;
    for (const o of receipt.rows) {
      let rowSum = o.price * o.amount;
      if (o.discount) {
        if (o.discount.type === "%") {
          rowSum -= rowSum * o.discount.value / 100;
        } else {
          rowSum -= o.discount.value;
        }
      }
      for (const d of receipt.discounts) {
        if (d.type === "%") {
          rowSum -= rowSum * (d.value / 100);
        } else {
          rowSum -= d.value;
        }
      }
      if (!vats[o.vat]) {
        vats[o.vat] = {vatPercentage: o.vat, totalWithoutVat: 0, totalVat: 0, totalSum: 0};
      }
      vats[o.vat].totalSum += rowSum;
      const vatLessSum = rowSum / (1 + o.vat / 100);
      vats[o.vat].totalWithoutVat += vatLessSum;
      vats[o.vat].totalVat += (rowSum - vatLessSum);
      totalVatlessSum += vatLessSum;
    }
    receipt.vats = vats;
    return totalVatlessSum;
  }

  public calculatePartialPaymentVat(receipt: Receipt, currentSum?: number) {
    /* let isLastPayment = false; */
    let paidSum = 0;
    let vatSum = 0;
    const totalSum = receipt.rows.reduce((sum, row) => sum + row.price * row.amount, 0);
    if (receipt.payments.length > 0) {
      paidSum = receipt.payments.reduce((sum, payment) => sum + payment.sum, 0);
    }
    if (!currentSum || currentSum === totalSum - paidSum) {
      currentSum = totalSum - paidSum;
      /* isLastPayment = true; */
    }
    /* const totalVat = receipt.rows.reduce((sum, row) => sum + ((row.price * row.amount) * (row.vat/100)), 0 ); */
    for (let i = 0; i < receipt.rows.length; i++) {
      const row = receipt.rows[i];
      let rowSum = row.price * row.amount;
      if (row.discount) {
        if (row.discount.type === "%") {
          rowSum -= rowSum * row.discount.value / 100;
        } else {
          rowSum -= row.discount.value;
        }
      } else if (receipt.discounts[0]?.type === "%") {
        rowSum -= rowSum * receipt.discounts[0].value / 100;
      } else if (receipt.discounts[0]?.type === "currency" && i === receipt.rows.length - 1) {
        rowSum -= receipt.discounts[0].value;
      }
      if (rowSum <= paidSum) {
        paidSum = paidSum - rowSum;
      } else {
        let yetToPay = 0;
        yetToPay = rowSum - paidSum;
        if (yetToPay <= currentSum) {
          vatSum = vatSum + (yetToPay * (row.vat / 100));
          currentSum = currentSum - yetToPay;
        } else {
          vatSum = vatSum + (currentSum * (row.vat / 100));
          currentSum = 0;
        }
        paidSum = 0;
        if (currentSum === 0) {
          break;
        }
      }
    }
    vatSum = Math.round((vatSum + Number.EPSILON) * 100) / 100;
    return vatSum;
  }

  convertToRow(product: SaleArticleDto): ReceiptRow {
    const row = this.clone(product);
    if (row.code) {
      row.saleArticleNumber = row.code;
    }
   /*  delete row.additionalInfo;
    delete row.desc; */
    return row;
  }
}
